import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SearchDocumentsEntity, SearchDocumentsFilterEntity } from './search.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as SearchActions from './search.actions';

export const SEARCH_DOCUMENS_FEATURE_KEY = 'searchDocuments';

export interface SearchDocumentsState extends EntityState<SearchDocumentsEntity> {
  query: string;
  results: SearchDocumentsEntity[];
  filters: SearchDocumentsFilterEntity[];
  total_items: number;
  current_page: number;
  loaded: boolean;
  error?: string | null;
}

export const searchDocumentsAdapter: EntityAdapter<SearchDocumentsEntity> =
  createEntityAdapter<SearchDocumentsEntity>();

export const initialSearchDocumentsState: SearchDocumentsState = searchDocumentsAdapter.getInitialState({
  query: '',
  results: [],
  filters: [],
  total_items: 0,
  current_page: 1,
  loaded: false,
});

const reducer = createReducer(
  initialSearchDocumentsState,
  on(SearchActions.searchDocuments, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(SearchActions.loadDocumentsSuccess, (state, { data }) => ({
    ...state,
    ...data,
    loaded: true,
    error: null,
  })),
  on(SearchActions.loadDocumentsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
  on(SearchActions.resetSearchDocuments, () => ({
    ...initialSearchDocumentsState,
  })),
  on(SearchActions.updateSearchDocumentBookmark, (state, { documentId, isBookmarked }) => ({
    ...state,
    results: state.results.map((doc) => (doc.id === documentId ? { ...doc, is_bookmarked: isBookmarked } : doc)),
  }))
);

export function searchDocumentsReducer(state: SearchDocumentsState | undefined, action: Action) {
  return reducer(state, action);
}
